<app-header></app-header>
<section class="container-xxl">
    <div class="breadcrumb-area">
        <app-plugin-breadcrumb [datacollection]="{data:P_data,'showEmpMen':showEmpMen,'emp_dtl':emp_dtl}"
            *ngIf="showBarComponent"></app-plugin-breadcrumb>
    </div>

    <div class="inner-page">
        <div class="inner-page-details">
            <div class="row">
                <div [ngClass]="navMenu ? 'col-xl-3 col-xxl-2' : ''" *ngIf="navMenu">
                    <div [style]="navmenuloadCss">
                        <app-plugin-navbar [datacollection]="{data:P_data}"
                            *ngIf="showNavComponent"></app-plugin-navbar>
                    </div>
                </div>
                <div [ngClass]="navMenu ? 'col-xl-9 col-xxl-10' : 'col-lg-12'">

                    <!-- INNER CONTENT - STARTS -->


                    <div class="inner-page-sidedetails">
                        <div id="section-New"></div>
                        <div class="inner-banner-image">
                            <div class="image-area">
                                <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
                            </div>
                        </div>

                        <div class="details"
                            *ngFor="let item of overviewList | paginate: { id:'pg1',itemsPerPage: limit, currentPage: currentPage,totalItems: totalRecords};">
                            <div class="title">
                                <h2 class="screen-reader"> {{ encDec.decodeHtml(language=='English'?item.title:item.titleInHindi)}}</h2>
                            </div>
                            <div class="description">

                                <div class="news">
                                    <div class="row g-3 magazine-grid">

                                        <div class="col-lg-3" *ngFor="let itemdtl of item.addDetails;">
                                            <div class="card">
                                                <div class="card-body text-center">
                                                    <div class="magazine-image screen-reader">
                                                        <div class="st-name" *ngIf="checkFile(itemdtl)==false">
                                                            {{ shortname(itemdtl.name) }}
                                                        </div>
                                                        <img [src]="backend_url+'storage/app/uploads/'+itemdtl.photo"
                                                            *ngIf="checkFile(itemdtl)==true" alt="upload_image">
                                                    </div>

                                                    <div class="magazine-txt screen-reader">{{
                                                        encDec.decodeHtml(language=='English'?itemdtl.name:itemdtl.nameInHindi)
                                                        }}</div>
                                                    <p class="mb-1 font-adjust screen-reader">{{
                                                        encDec.decodeHtml(language=='English'?itemdtl.designation:itemdtl.designationInHindi)
                                                        }}</p>
                                                    <small class="mb-1 screen-reader" *ngIf="encDec.decodeHtml( language=='English'?itemdtl.location:itemdtl.locationInHindi)!==''"><i
                                                            class="bi bi-pin-map me-1"></i>{{encDec.decodeHtml( language=='English'?itemdtl.location:itemdtl.locationInHindi)
                                                        }}</small>
                                                    <small class="mb-1 screen-reader" *ngIf="encDec.decodeHtml(language=='English'?itemdtl.emailId:itemdtl.emailIdInHindi)!==''"> <a href="javascript:void(0)" [attr.title]="language=='English'?'E-mail':'ई-मेल'"> <i
                                                                class="bi bi-envelope me-1 font-adjust"></i>
                                                            {{
                                                            encDec.decodeHtml(language=='English'?itemdtl.emailId:itemdtl.emailIdInHindi)
                                                            }}
                                                        </a></small>
                                                    <small class="text-muted mb-1 screen-reader" *ngIf="encDec.decodeHtml(language=='English'?itemdtl.contactNo:itemdtl.contactNoInHindi)!==''">
                                                        <a href="javascript:void(0)" [attr.title]="language=='English'?'Phone No.':'फोन नंबर'"> <i
                                                                class="bi bi-telephone-outbound me-1 font-adjust"></i>
                                                            {{
                                                            encDec.decodeHtml(language=='English'?itemdtl.contactNo:itemdtl.contactNoInHindi)
                                                            }}
                                                        </a>
                                                    </small>
                                                    <small class="text-muted screen-reader" *ngIf="encDec.decodeHtml(language=='English'?itemdtl.wEF:itemdtl.wEFInHindi)!==''">W.E.F: {{
                                                        encDec.decodeHtml(language=='English'?itemdtl.wEF:itemdtl.wEFInHindi)
                                                        }}</small>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>


                                <div class="inner-content">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="content-details">
                                                
                                                <div class="content-part font-adjust screen-reader" [innerHTML]="encDec.decodeHtml(language=='English'?item.description:item.descriptionInHindi)">

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                
                            </div>

                        </div>

                        <pagination-controls id="pg1" class="text-center screen-reader" (pageChange)="pageChanged($event)"
                            *ngIf="totalRecords > 20"></pagination-controls>
                    </div>

                    <!-- INNER CONTENT - ENDS -->
                </div>
            </div>
        </div>
    </div>

</section>

<app-clients></app-clients>

<app-footer></app-footer>